import { Alert, Avatar } from '@mui/material';
import Grid from '@mui/material/Grid2';
import DownloadIcon from '@mui/icons-material/Download';

import HeaderDivider from '../../../Lib/UI/Components/HeaderDivider';
import AsyncStatus from '../../../Lib/UI/Components/AsyncStatus';
import AsyncStatusButton from '../../../Lib/UI/Components/AsyncStatusButton';
import CustomList from '../../../Lib/UI/Components/CustomList';

import useDownloadMapDataList, { DownloadMapDataListProps } from '../hooks/useDownloadMapDataList';
import DownloadMapDataListItem from './DownloadMapDataListItem';


const DownloadMapDataList = (props: DownloadMapDataListProps): JSX.Element => {

    const list = useDownloadMapDataList(props);

    return (        
        <>
            <HeaderDivider title="Current Map View" />

            <Grid                     
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Avatar 
                    variant="square"
                    sx={{ width: { xs: 200, sm: 250, md: 300 }, height: { xs: 200, sm: 250, md: 300 }}} 
                    slotProps={{ img: { sx: { height: 'auto', width: 'auto', maxHeight: '100%', maxWidth: '100%' } } }} 
                    src={list.currentThumbUrl ?? undefined}
                >
                    <DownloadIcon fontSize="large" />
                </Avatar>

                {list.downloadAvailable && <AsyncStatusButton action={list.startDownloadStatus} title="Download map data for offline use..." onClick={list.startDownload}>Start Download</AsyncStatusButton>}
                {list.zoomIsOutOfRange && <Alert severity='warning'>Download is not available at the current map zoom level.</Alert>}
            </Grid>

            <HeaderDivider title="History" />

            <AsyncStatus action={list.listStatus} showChildrenWhenComplete={true} busyLabel="Loading download history..." retry={list.loadHistory}>

            {!!list.historyItems && 
                <CustomList>
                {list.historyItems.map((item, _idx) =>
                    <DownloadMapDataListItem key={item.id} seederActions={props.tileCacheSeeder} item={item}/>
                )}
                </CustomList>
            }

            </AsyncStatus>
        </>
    );
};

export default DownloadMapDataList;